import React, { useState, useContext } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logo from "../../../images/logo/onboardingLogoSmall.svg";
import logoText from "../../../images/logo/onboardingLogo.svg";
// import { ThemeContext } from "../../../context/ThemeContext";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const NavHader = ({ toggle, setToggle }) => {
  console.log(toggle, "toggle");
  return (
    <div className="nav-header">
      <Link to="/" className="brand-logo">
        <img
          className="logo-abbr d-block d-lg-none"
          src={logo}
          alt=""
          style={{ display: "block !important" }}
        />
        <img className="logo-compact" src={logoText} alt="" />
        <img className="brand-title" src={logoText} alt="" />
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
